import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import FollowDealerButton from '../FollowDealerButton';
import RightArrow from 'dibs-icons/exports/legacy/ArrowRight';

import style from './successContent.scss';

function RequestShippingSuccessContentComponent(props) {
    const { seller, userId, isMC } = props;

    return (
        <div data-tn="shipping-request-modal-success">
            <ModalBody>
                <p className={style.sqrSuccessMessage}>
                    <FormattedMessage
                        id="dc.requestShippingModal.success_message"
                        defaultMessage="You’ll receive an email when your quote is available."
                    />
                </p>
                <p className={style.sqrSuccessMessage}>
                    <FormattedMessage
                        id="dc.requestShippingModal.meanwhile_caption"
                        defaultMessage="Meanwhile, review your request anytime. "
                    />
                    <Link href="/inbox/" className={style.sqrSuccessLink}>
                        <FormattedMessage
                            id="dc.requestShippingModal.my_conversations"
                            defaultMessage="Inbox"
                        />
                        <RightArrow className={style.sqrCtaArrow} />
                    </Link>
                </p>
            </ModalBody>
            <div className={style.sqrSuccessFooter}>
                <div className={style.sqrSuccessFooterTitle}>
                    <FormattedMessage
                        id="dc.requestShippingModal.success_footer_title"
                        defaultMessage="stay up to date"
                    />
                </div>
                <div className={style.sqrSuccessFooterText}>
                    <FormattedMessage
                        id="dc.requestShippingModal.success_footer_text"
                        defaultMessage="Follow this seller to get weekly updates on new arrivals."
                    />
                </div>
                <FollowDealerButton seller={seller} currentUserId={userId} isMC={isMC} />
            </div>
        </div>
    );
}

RequestShippingSuccessContentComponent.propTypes = {
    seller: PropTypes.object.isRequired,
    userId: PropTypes.string,
    isMC: PropTypes.bool,
};

export const RequestShippingSuccessContent = createFragmentContainer(
    RequestShippingSuccessContentComponent,
    {
        seller: graphql`
            fragment RequestShippingSuccessContent_seller on Seller {
                ...FollowDealerButton_seller
            }
        `,
    }
);
